import { create } from 'zustand'

interface AuthState {
  token: string | null
  isAuthenticated: boolean
  setToken: (token: string) => void
  logout: () => void
  checkAuth: () => void
}

export const useAuth = create<AuthState>((set) => ({
  token: localStorage.getItem('supportToken'),
  isAuthenticated: !!localStorage.getItem('supportToken'),
  setToken: (token) => {
    localStorage.setItem('supportToken', token)
    set({ token, isAuthenticated: true })
  },
  logout: () => {
    localStorage.removeItem('supportToken')
    set({ token: null, isAuthenticated: false })
  },
  checkAuth: () => {
    const token = localStorage.getItem('supportToken')
    set({ token, isAuthenticated: !!token })
  }
}))